import { styled } from '@mui/material';

const PREFIX = 'PublicCompsList';

export const publicCompsListClasses = {
  groupLabel: `${PREFIX}-groupLabel`,
  option: `${PREFIX}-option`,
};

export const PublicCompsListRoot = styled('div')(({ theme }) => ({
  [`& .${publicCompsListClasses.groupLabel}`]: {
    color: theme.palette.grey[300],
    fontSize: '10px',
    fontWeight: 'bold',
  },

  [`& .${publicCompsListClasses.option}`]: {
    '& > span.icon': {
      color: theme.palette.green[500],
      marginLeft: 5,
      display: 'inline-flex',
    },
  },
}));